import { render, staticRenderFns } from "./assignMenuSelect.vue?vue&type=template&id=36a2da41"
import script from "./assignMenuSelect.vue?vue&type=script&lang=js"
export * from "./assignMenuSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36a2da41')) {
      api.createRecord('36a2da41', component.options)
    } else {
      api.reload('36a2da41', component.options)
    }
    module.hot.accept("./assignMenuSelect.vue?vue&type=template&id=36a2da41", function () {
      api.rerender('36a2da41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/brand/settings/assignMenuSelect.vue"
export default component.exports